import React, { Component } from 'react'
import { Button, Col, Modal, Row, Space, Switch, Tabs, Typography, notification } from 'antd'
import delta from '../../../../../assets/images/delta.png'
import deltaLogo from '../../../../../assets/images/DL-red.png'
import AcDetails from './acdetails'
import ContainerDetails from './containerdetails'
import AcType359 from './actype359'
import AcType764 from './actype764'
import AcType763 from './actype763'
import AcType333 from './actype333'
import AcType339 from './actype339'
import AcType332 from './actype332'
import http from '../../../../../utils/http'
import DryIce from './dryice'
import moment from 'moment'
import Cookies from 'universal-cookie'
import html2canvas from 'html2canvas'
import TruckLoading from '../truckloading'

const { Text } = Typography
const cookies = new Cookies()
const { TabPane } = Tabs
class WeightAndBalance extends Component {
  constructor(props) {
    super(props)
    this.state = {
      flight: {
        flight_no: null,
        flight_date: null,
      },
      recordid: null,
      record: null,
      wgt_bal_status: null,
      aft_index: null,
      cargo_margin: null,
      ship: null,
      type: 'Domestic',
      pax: {
        c: 0,
        f: 0,
        w: 0,
        y: 0
      },
      fuel: 0,
      position: {
        pallet: {},
        cargo: {},
        bulk: 0
      },
      season: 'Summer',
      acdetails: {},
      ac_title: '',
      viewMode: 'sm',
      activeTab: 'wnb',
      visibleTabs: ['wnb', 'initial', 'final'],
      station: cookies.get('station'),
      user_id: cookies.get('id'),
      truckplanner: false,
      copy: false,
      ulds: [],
      isSubmitTimerActive: false,
    }
    this.acTypeText = ''
    this.modalContentRef = React.createRef()
    this.eventSource = null
    this.hasLocalDraftChanges = false
    this.localEditVersion = 0
    this.submitTimer = null
    this.isSubmitting = false
    this.pendingSubmit = false
  }

  markLocalEdit = () => {
    this.hasLocalDraftChanges = true
    this.localEditVersion += 1
  }

  componentDidMount() {
    // Inject .wnb-modal-expanded CSS if not already present
    if (typeof document !== 'undefined' && !document.getElementById('wnb-modal-expanded-style')) {
      const style = document.createElement('style')
      style.id = 'wnb-modal-expanded-style'
      style.innerHTML = `
      .wnb-modal-expanded {
        max-height: none !important;
        height: auto !important;
        overflow: visible !important;
      }
      /* Also expand the modal body and wrapper when screenshotting */
      .wnb-modal .ant-modal-content,
      .wnb-modal .ant-modal-body {
        max-height: none !important;
        height: auto !important;
        overflow: visible !important;
      }
    `
      document.head.appendChild(style)
    }
    this.fetchData()
    this.startEventSource() // Start the EventSource when the component mounts
  }

  componentDidUpdate(prevProps) {
    if (this.props.editRecord.fleet !== prevProps.editRecord.fleet || this.props.editRecordId !== prevProps.editRecordId) {
      this.fetchData()
      if (this.props.editRecordId !== prevProps.editRecordId)
        this.startEventSource() // Restart the EventSource if the flight changes
    }
  }

  componentWillUnmount() {
    if (this.eventSource) {
      this.eventSource.close()
    }
    if (this.submitTimer) {
      clearTimeout(this.submitTimer)
      this.submitTimer = null
    }
  }

  executeSubmit = () => {
    if (this.isSubmitting) {
      this.pendingSubmit = true
      return Promise.resolve()
    }

    this.isSubmitting = true
    const submitEditVersion = this.localEditVersion
    let fuel = this.state.fuel
    let position = { ...this.state.position }

    if (this.props.wgt_unit == 'KG') {
      position.pallet = Object.keys(position.pallet || {}).reduce((acc, key) => {
        // convert to lbs for submission
        acc[key] = position.pallet[key] ? Math.round(position.pallet[key] * 2.20462) : 0
        return acc
      }
      , {})
      position.cargo = Object.keys(position.cargo || {}).reduce((acc, key) => {
        // convert to lbs for submission
        acc[key] = position.cargo[key] ? Math.round(position.cargo[key] * 2.20462) : 0
        return acc
      }
      , {})
    } else {
      // convert to kg for submission
      fuel = fuel ? Math.round(fuel / 2.20462) : 0
    }

    const finish = () => {
      this.isSubmitting = false
      if (this.pendingSubmit) {
        this.pendingSubmit = false
        return this.executeSubmit()
      }
      return Promise.resolve()
    }

    return http.post(`/wgt_bal_plan/${this.state.recordid}`, {
      ship: this.state.ship,
      type: this.state.type,
      pax: this.state.pax,
      fuel: fuel,
      position: position,
      season: this.state.season,
    }).then(() => {
      if (this.localEditVersion === submitEditVersion) {
        this.hasLocalDraftChanges = false
      }
      return finish()
    }).catch(() => {
      // Keep local draft dirty so user input is not overwritten on save failure.
      return finish()
    })
  }

  startEventSource = () => {
    if (this.eventSource) {
      this.eventSource.close()
    }

    this.eventSource = new EventSource(process.env.REACT_APP_API_URL + `events?pgtype=wb&stn=${this.state.station}&flight=${this.props.editRecordId}`)
    this.eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data)
      // eslint-disable-next-line
      console.log('Received event:', data)
      let flightData = data?.DETAILS?.data
      if (data?.msg == 'wgt_bal_plan')
        this.setState((prevState) => ({
          record: {
            ...prevState.record,
            ...flightData
          }
        }), () => {
          const preserveLocalDraft = this.hasLocalDraftChanges
          this.renderData(false, preserveLocalDraft)
        })

    }
  }

  fetchData = () => {
    http.get(`/w_b_flight/${this.props.editRecordId}`).then(({ data }) => {
      this.hasLocalDraftChanges = false
      this.localEditVersion = 0
      this.setState({
        recordid: this.props.editRecordId,
        record: {
          fleet: this.props.editRecord?.fleet,
          ...data.data
        }
      }, () => {
        this.renderData()
      })
    })
  }

  renderData = (p=false, preserveLocalDraft=false) => {
    let record = { ...this.state.record }
    this.getULD()
    if (p == 'initial') {
      record = {
        ...this.state.record,
        ...this.state.record?.init_wgt_bal_plan,
        build_plan: this.state.record?.init_build_plan?.data?.build_plan
      }
    }
    else if (p == 'final') {
      record = {
        ...this.state.record,
        ...this.state.record?.final_wgt_bal_plan,
        build_plan: this.state.record?.final_build_plan?.data?.build_plan
      }
    }
    let ulds = {}
    switch (this.state.record?.fleet) {
    case '359':
      ulds = {
        p11: 'PMC',
        p21: 'PAG',
        p22: 'PMC',
        p23: 'PMC',
        p24: 'PMC',
        p25: 'PMC',
        p31: 'PMC',
        p32: 'PMC',
        p33: 'PMC',
        p34: 'PMC',
        p41: 'PMC',
      }
      break
    case '764':
      ulds = {
        p11: 'PMC',
        p21: 'PMC',
        p22: 'PMC',
        p23: 'PMC',
        p24: 'PMC',
      }
      break
    case '763':
      ulds = {
        p11: 'PMC',
        p21: 'PMC',
        p22: 'PMC',
        p23: 'PMC',
        p24: 'PMC',
      }
      break
    case '333':
      ulds = {
        p11: 'PMC',
        p21: 'PMC',
        p22: 'PMC',
        p23: 'PMC',
        p24: 'PMC',
        p25: 'PMC',
        p32: 'PAG',
        p33: 'PMC',
        p34: 'PAG',
        p41: 'PMC',
      }
      break
    case '339':
      ulds = {
        p11: 'PMC',
        p21: 'PMC',
        p22: 'PMC',
        p23: 'PMC',
        p24: 'PMC',
        p25: 'PMC',
        p33: 'PMC',
        p34: 'PAG',
        p41: 'PMC',
      }
      break
    case '332':
      ulds = {
        p21: 'PMC',
        p22: 'PMC',
        p23: 'PMC',
        p24: 'PMC',
        p25: 'PMC',
        p31: 'PMC',
        p32: 'PMC',
        p33: 'PMC',
        p41: 'PMC',
      }
      break
    default:
      ulds = {}
    }


    if (record?.wgt_bal_plan) {
      let positionData = { ...record?.wgt_bal_plan?.position } || {
        pallet: {},
        cargo: {},
        bulk: 0
      }
      let fuel = record?.wgt_bal_plan?.fuel || 0
      if (!positionData?.pallet_uld || (positionData?.pallet_uld && Object.keys(positionData?.pallet_uld).length == 0)) {
        positionData['pallet_uld'] = ulds
      }
      if (this.props.wgt_unit == 'KG') {
        positionData.pallet = Object.keys(positionData.pallet || {}).reduce((acc, key) => {
          acc[key] = positionData.pallet[key] ? Math.round(positionData.pallet[key] / 2.20462) : 0
          return acc
        }
        , {})
        positionData.cargo = Object.keys(positionData.cargo || {}).reduce((acc, key) => {
          acc[key] = positionData.cargo[key] ? Math.round(positionData.cargo[key] / 2.20462) : 0
          return acc
        }
        , {})
      } else {
        fuel = record?.wgt_bal_plan?.fuel ? Math.round(record?.wgt_bal_plan?.fuel * 2.20462) : 0
      }

      this.setState({
        flight: {
          flight_no: record?.flight_no,
          flight_date: moment(record?.flight_date).format('DDMMMYY')?.toUpperCase(),
        },
        wgt_bal_status: record?.wgt_bal_status,
        aft_index: record?.aft_index,
        ship: preserveLocalDraft ? this.state.ship : record?.wgt_bal_plan?.ship,
        type: preserveLocalDraft ? this.state.type : record?.wgt_bal_plan?.type,
        pax: preserveLocalDraft ? this.state.pax : record?.wgt_bal_plan?.pax,
        fuel: preserveLocalDraft ? this.state.fuel : fuel,
        season: preserveLocalDraft ? this.state.season : record?.wgt_bal_plan?.season,
        position: preserveLocalDraft ? this.state.position : positionData,
        cargo_margin: record?.wgt_bal_plan?.cargo_margin
      })
    } else {
      this.setState({
        flight: {
          flight_no: record?.flight_no,
          flight_date: moment(record?.flight_date).format('DDMMMYY')?.toUpperCase(),
        },
        ship: preserveLocalDraft ? this.state.ship : null,
        type: preserveLocalDraft ? this.state.type : 'Domestic',
        pax: preserveLocalDraft ? this.state.pax : {
          c: 0,
          f: 0,
          w: 0,
          y: 0
        },
        fuel: preserveLocalDraft ? this.state.fuel : 0,
        position: preserveLocalDraft ? this.state.position : {
          pallet: {},
          cargo: {},
          bulk: 0,
          pallet_uld: ulds
        },
        season: preserveLocalDraft ? this.state.season : 'Summer',
        cargo_margin: 0
      })
    }
  }


  onSubmit = (options = {}) => {
    const { immediate = false } = options

    if (this.submitTimer) {
      clearTimeout(this.submitTimer)
      this.submitTimer = null
    }

    if (this.state.isSubmitTimerActive) {
      this.setState({ isSubmitTimerActive: false })
    }

    if (immediate) {
      return this.executeSubmit()
    }

    this.setState({ isSubmitTimerActive: true })

    this.submitTimer = setTimeout(() => {
      this.submitTimer = null
      this.setState({ isSubmitTimerActive: false })
      this.executeSubmit()
    }, 2000)

    return Promise.resolve()
  }

  onChange = (e) => {
    let name = e.target.name
    let value = e.target.value
    this.markLocalEdit()
    this.setState({ [name]: value }, () => {
      this.onSubmit()
    })

  }

  onChangePax = (e) => {
    let name = e.target.name
    let value = e.target.value
    this.markLocalEdit()
    this.setState({
      pax: {
        ...this.state.pax,
        [name]: value
      }
    }, () => {
      this.onSubmit()
    })
  }

  onChangePosition = (e, i, t) => {
    this.markLocalEdit()
    if (t === 'bulk') {
      this.setState({
        position: {
          ...this.state.position,
          [t]: e
        },
      }, () => {
        this.onSubmit()
      })
    }
    else {
      this.setState({
        position: {
          ...this.state.position,
          [t]: {
            ...this.state.position[t],
            [i]: e
          }
        },
      }, () => {
        this.onSubmit()
      })
    }
  }

  aftStatus = (aftIndex) => {
    let aftStatus = ''
    if (aftIndex) {
      if (aftIndex > 81 && aftIndex < 10000) {
        aftStatus = 'Tail Heavy'
      }
      else if (aftIndex < 19) {
        aftStatus = 'Nose Heavy'
      }
      return aftStatus
    }
  }

  aftIndexStyle = (aftIndex) => {
    if (aftIndex) {
      if (aftIndex <= 0 || aftIndex >= 100) {
        return {
          backgroundColor: 'var(--danger)',
          color: 'white',
          fontWeight: 'bold'
        }
      } else if ((aftIndex >= 1 && aftIndex <= 19) || (aftIndex >= 81 && aftIndex <= 99)) {
        return {
          backgroundColor: '#d9d301',
          color: 'black'
        }
      } else {
        return {
          backgroundColor: 'green',
          color: 'white',
          fontWeight: 'bold'
        }
      }
    } else {
      return { color: 'black' }
    }
  }

  clearBin = () => {
    this.setState({
      position: {
        pallet: {},
        cargo: {},
        bulk: 0
      }
    }, () => {
      this.onSubmit()
    })
  }

  lockWB = () => {
    http.post(`/wgt_bal_lock/${this.state.recordid}`, {})
  }

  unlockWB = (data) => {
    http.post(`/wgt_bal_unlock/${this.state.recordid}`, data)
  }

  trimPlan = () => {
    http.post(`/trim_build_plan/${this.state.recordid}`, {})
  }

  openTruckPlanner = (value) => {
    this.setState({ truckplanner: value })
  }

  acTypeChange = () => {
    let optimal = true
    let tare = 0
    if ([332, 333, 339, 359].includes(this.state.record?.fleet)) {
      tare = this.props.wgt_unit === 'KG' ? 82 : 181
    } else {
      tare = this.props.wgt_unit === 'KG' ? 92 : 203
    }
    let bag_pos_wgt = this.state.record?.wgt_bal_plan?.bag_pos_wgt || 0
    if (this.props.wgt_unit === 'KG') {
      bag_pos_wgt = bag_pos_wgt * 0.453592
    }
    bag_pos_wgt = Math.round((bag_pos_wgt + tare) / 10) * 10 // round to nearest 10

    switch (this.state.record?.fleet) {
    case '359':
      return (
        (!this.state.position?.pallet?.p34 && this.state.position?.pallet?.p33) || (this.state.position?.pallet?.p34 && !this.state.position?.pallet?.p33) || (!this.state.position?.pallet?.p32 && this.state.position?.pallet?.p31) || (this.state.position?.pallet?.p32 && !this.state.position?.pallet?.p31) || (!this.state.position?.pallet?.p25 && this.state.position?.pallet?.p24) || (this.state.position?.pallet?.p25 && !this.state.position?.pallet?.p24) || (!this.state.position?.pallet?.p23 && this.state.position?.pallet?.p22) || (this.state.position?.pallet?.p23 && !this.state.position?.pallet?.p22) || (!this.state.position?.pallet?.p21 && this.state.position?.pallet?.p11) || (this.state.position?.pallet?.p21 && !this.state.position?.pallet?.p11) || (this.state.position?.pallet?.p41) ? optimal = false : optimal = true,
        <AcType359
          flight={this.state.flight}
          optimal={optimal}
          onChange={this.onChangePosition}
          position={this.state.position}
          clearBin={this.clearBin}
          ulds={this.state.ulds}
          bag_wgt={bag_pos_wgt}
          wgt_unit={this.props.wgt_unit}
          onSubmit={this.onSubmit}
          editRecord={this.state.record}
          copy={this.state.copy}
          viewMode={this.state.viewMode}
          disableInputs={this.props.disableInputs}
        />
      )
    case '764':
      optimal = Object.keys(this.state.position?.cargo_uld || {}).some(key => ['LD3'].includes(this.state.position?.cargo_uld[key])) ? false : true
      return (
        <AcType764
          flight={this.state.flight}
          optimal={optimal}
          onChange={this.onChangePosition}
          position={this.state.position}
          clearBin={this.clearBin}
          ulds={this.state.ulds}
          bag_wgt={bag_pos_wgt}
          wgt_unit={this.props.wgt_unit}
          onSubmit={this.onSubmit}
          editRecord={this.state.record}
          copy={this.state.copy}
          viewMode={this.state.viewMode}
          disableInputs={this.props.disableInputs}
        />
      )
    case '763':
      optimal = Object.keys(this.state.position?.cargo_uld || {}).some(key => ['LD3'].includes(this.state.position?.cargo_uld[key])) ? false : true
      return (
        <AcType763
          flight={this.state.flight}
          optimal={optimal}
          onChange={this.onChangePosition}
          position={this.state.position}
          clearBin={this.clearBin}
          ulds={this.state.ulds}
          bag_wgt={bag_pos_wgt}
          wgt_unit={this.props.wgt_unit}
          onSubmit={this.onSubmit}
          editRecord={this.state.record}
          copy={this.state.copy}
          viewMode={this.state.viewMode}
          disableInputs={this.props.disableInputs}
        />
      )
    case '333':
      ((this.state.position?.pallet_uld?.p33 == 'PMC' && this.state.position?.pallet?.p33 > 0) && ((this.state.position?.pallet_uld?.p32 == 'PMC' && this.state.position?.pallet?.p32 > 0) || (this.state.position?.pallet_uld?.p34 == 'PMC' && this.state.position?.pallet?.p34 > 0))) ? optimal = 'Not Allowed: 32P and 34P must be PAG or empty if PMC in 33P' : (!this.state.position?.pallet?.p41 && this.state.position?.pallet?.p34) || (this.state.position?.pallet?.p41 && !this.state.position?.pallet?.p34) || (!this.state.position?.pallet?.p33 && this.state.position?.pallet?.p32) || (this.state.position?.pallet?.p33 && !this.state.position?.pallet?.p32) || (!this.state.position?.pallet?.p25 && this.state.position?.pallet?.p24) || (this.state.position?.pallet?.p25 && !this.state.position?.pallet?.p24) || (!this.state.position?.pallet?.p23 && this.state.position?.pallet?.p22) || (this.state.position?.pallet?.p23 && !this.state.position?.pallet?.p22) || (!this.state.position?.pallet?.p21 && this.state.position?.pallet?.p11) || (this.state.position?.pallet?.p21 && !this.state.position?.pallet?.p11) ? optimal = 'Suboptimal Configuration: Unpaired Pallet' : optimal = true
      return (
        <AcType333
          ship={this.state.ship}
          flight={this.state.flight}
          optimal={optimal}
          onChange={this.onChangePosition}
          position={this.state.position}
          clearBin={this.clearBin}
          ulds={this.state.ulds}
          bag_wgt={bag_pos_wgt}
          wgt_unit={this.props.wgt_unit}
          onSubmit={this.onSubmit}
          editRecord={this.state.record}
          copy={this.state.copy}
          viewMode={this.state.viewMode}
          disableInputs={this.props.disableInputs}
        />
      )
    case '339':
      ((this.state.position?.pallet_uld?.p33 == 'PMC' && this.state.position?.pallet?.p33 > 0) && ((this.state.position?.pallet_uld?.p34 == 'PMC' && this.state.position?.pallet?.p34 > 0))) ? optimal = 'ERROR - If a 96” pallet is loaded in position 33P, position 34P must be PAG.' :
        (this.state.position?.pallet_uld?.p34 == 'PMC' && this.state.position?.pallet?.p34 > 0) && (this.state.position?.cargo?.l34 > 0 || this.state.position?.cargo?.r34 > 0) ? optimal = 'ERROR - 34P must be PAG if LD3/PLA in 34L/R or LD2/PLB in 21L/R' :
          (!this.state.position?.pallet?.p41 && this.state.position?.pallet?.p34) || (this.state.position?.pallet?.p41 && !this.state.position?.pallet?.p34) || (!this.state.position?.pallet?.p25 && this.state.position?.pallet?.p24) || (this.state.position?.pallet?.p25 && !this.state.position?.pallet?.p24) || (!this.state.position?.pallet?.p23 && this.state.position?.pallet?.p22) || (this.state.position?.pallet?.p23 && !this.state.position?.pallet?.p22) || (!this.state.position?.pallet?.p21 && this.state.position?.pallet?.p11) || (this.state.position?.pallet?.p21 && !this.state.position?.pallet?.p11) || (this.state.position?.pallet?.p33) ? optimal = false : optimal = true
      return (
        <AcType339
          flight={this.state.flight}
          optimal={optimal}
          onChange={this.onChangePosition}
          position={this.state.position}
          clearBin={this.clearBin}
          ulds={this.state.ulds}
          bag_wgt={bag_pos_wgt}
          wgt_unit={this.props.wgt_unit}
          onSubmit={this.onSubmit}
          editRecord={this.state.record}
          copy={this.state.copy}
          viewMode={this.state.viewMode}
          disableInputs={this.props.disableInputs}
        />
      )
    case '332':
      (!this.state.position?.pallet?.p41 && this.state.position?.pallet?.p33) || (this.state.position?.pallet?.p41 && !this.state.position?.pallet?.p33) || (!this.state.position?.pallet?.p32 && this.state.position?.pallet?.p31) || (this.state.position?.pallet?.p32 && !this.state.position?.pallet?.p31) || (!this.state.position?.pallet?.p24 && this.state.position?.pallet?.p23) || (this.state.position?.pallet?.p24 && !this.state.position?.pallet?.p23) || (!this.state.position?.pallet?.p22 && this.state.position?.pallet?.p21) || (this.state.position?.pallet?.p22 && !this.state.position?.pallet?.p21) ? optimal = false : optimal = true
      return (
        <AcType332
          flight={this.state.flight}
          optimal={optimal}
          onChange={this.onChangePosition}
          position={this.state.position}
          clearBin={this.clearBin}
          ulds={this.state.ulds}
          bag_wgt={bag_pos_wgt}
          wgt_unit={this.props.wgt_unit}
          onSubmit={this.onSubmit}
          editRecord={this.state.record}
          copy={this.state.copy}
          viewMode={this.state.viewMode}
          disableInputs={this.props.disableInputs}
        />
      )
    default:
      return null
    }
  }

  acTypeName = () => {
    let acTypeText = ''
    switch (this.props.editRecord?.fleet) {
    case '359':
      acTypeText = 'AIRBUS A350-900B'
      break
    case '764':
      acTypeText = 'BOEING 767-400ER'
      break
    case '763':
      acTypeText = 'BOEING 767-300ER'
      break
    case '333':
      acTypeText = 'AIRBUS A330-300'
      break
    case '339':
      acTypeText = 'AIRBUS A330-900NEO'
      break
    case '332':
      acTypeText = 'AIRBUS A330-200'
      break
    default:
      return null
    }
    return acTypeText
  }

  getULD = () => {
    let ulds = []
    if (this.state.record?.build_uld && this.state.record?.build_uld?.length > 0) {
      this.state.record?.build_uld?.map((u) => {
        let wgt = u.wgt || u?.data?.tare_wgt || 0
        let remark = ''
        let pri = []
        if (this.state.record && this.state.record?.build_plan && this.state.record?.build_plan?.length > 0) {
          this.state.record?.build_plan?.map((item) => {
            if (item?.ulds && item?.ulds?.length > 0) {
              item?.ulds?.map((uld) => {
                if (uld.id && uld.id == u.id) {
                  wgt = !u.wgt ? wgt + parseFloat(uld.wgt || 0) : wgt
                  uld.remark ? pri.push(uld.remark) : {}
                }
              }
              )
            }
          })
        }
        // sort priority  
        if (pri && pri.length > 0) {
          pri.sort((a, b) => a - b)
          remark = pri[0]
        }
        ulds.push({
          id: u.id,
          uld_type: u.type + (u.uld_no ? u.uld_no : ''),
          wgt: wgt,
          remark: remark
        })
      })
    }
    // eslint-disable-next-line
    console.log('ulds---------', ulds, this.state.record?.build_plan)
    this.setState({ ulds })
  }

  callbackTabClicked = (key) => {
    this.setState({ activeTab: key })
    if (key === 'initial') {
      this.renderData('initial') // Refresh data to ensure latest info is shown in Initial W&B
      this.setState({
        copy: true,
        ccPlanModalVisible: true
      })
    }
    else if (key === 'final') {
      this.renderData('final') // Refresh data to ensure latest info is shown in Final W&B
      this.setState({
        copy: true,
        ccPlanModalVisible: true
      })
    }
    else {
      this.renderData() // Refresh data for W&B tab as well, in case there were changes in Initial/Final that affect it
      this.setState({
        copy: false,
        ccPlanModalVisible: false
      })
    }
  }

  onTabEdit = (targetKey, action) => {
    if (action === 'remove') {
      this.removeTab(targetKey)
    }
  }

  removeTab = (targetKey) => {
    const { visibleTabs, activeTab } = this.state
    const newVisibleTabs = visibleTabs.filter(key => key !== targetKey)

    // Call unlock function based on which tab is being removed
    if (targetKey === 'initial') {
      this.unlockWB({ init: true })
    } else if (targetKey === 'final') {
      this.unlockWB({ final: true })
    }

    // If removing the active tab, switch to the first available tab
    let newActiveTab = activeTab
    if (activeTab === targetKey && newVisibleTabs.length > 0) {
      newActiveTab = newVisibleTabs[0]
    }

    this.setState({
      visibleTabs: newVisibleTabs,
      activeTab: newActiveTab
    })
  }

  handleLockAndScreenshot = () => {
    this.lockWB() // Lock the W&B plan first
    setTimeout(() => {
      let fieldName = 'wandb_conf'
      let type = 'proposed_'
      if (!this.state.record?.init_wgt_bal_plan) {
        fieldName = 'wandb_conf'
        type = 'proposed_'
      } else {
        fieldName = 'wandb_conf2'
        type = 'final_w'
      }
      const node = this.modalContentRef.current
      if (node) {
        node.classList.add('wnb-modal-expanded')
        node.scrollTop = 0
        setTimeout(() => {
          html2canvas(node).then(canvas => {
            node.classList.remove('wnb-modal-expanded')
            canvas.toBlob(blob => {
              // if (this.props.onWandbImageReady) {
              // Pass the blob and filename to parent
              const filename = `WeightAndBalance_${type}${this.state.record.flight_no || 'flight'}.png`
              this.handleAuditScreenshotUpload(blob, filename, fieldName)
              // }
            }, 'image/png')
          })
        }, 100)
      }
    }, 500)
  }

  attachAudit = async (file, filename, fieldName) => {
    if (!file) return
    const headers = {
      station: this.state.station,
      user_id: this.state.user_id,
    }
    const formdata = new FormData()
    if (fieldName === 'wandb_conf') {
      formdata.append('wandb_conf', file, filename) //Weight & Balance Initial
    } else if (fieldName === 'load_trac_conf') {
      formdata.append('load_trac_conf', file, filename) //Proposed Build Plan
    } else if (fieldName === 'build_plan_conf') {
      formdata.append('build_plan_conf', file, filename) //Final Build Plan
    } else if (fieldName === 'wandb_conf2') {
      formdata.append('wandb_conf2', file, filename) //Weight & Balance Final
    }
    await http.put(`/attach_audit_file/${this.state.recordid}`, formdata, { headers })
      .then((resp) => {
        if (resp?.data?.data) {
          notification.success({
            message: 'Success',
            description: 'Audit files uploaded successfully!',
          })
        } else {
          notification.error({
            message: 'Failed',
            description: resp?.data?.message || 'Upload failed',
          })
        }
      })
      .catch(() => {
        notification.error({
          message: 'Failed',
          description: 'Upload failed',
        })
      })
  }
  
  handleAuditScreenshotUpload = (blob, filename, fieldName) => {
    if (!blob) return
    const file = new File([blob], filename, { type: 'image/png' })
    this.attachAudit(file, filename, fieldName)
  }

  render() {
    const acType = this.acTypeChange()
    const acName = this.acTypeName()
    const modalTitle =
      <Row gutter={[{
        xs: 0,
        sm: 0,
        md: 24,
        lg: 48
      }, {
        xs: 24,
        sm: 24,
        md: 24,
        lg: 48
      },]} className='modal-title fv-middle'>
        <Col
          flex='none'
          className=''>
          <div className='dl-logo'><img src={delta} /> </div>
          <Text className='wnb-flight'> {this.state.flight?.flight_no} | {this.state.flight?.flight_date}</Text>
        </Col>
        <Col flex={1} className='content-ht-half'>
          {/* <div className='d-flex ac-title-wrapper'> */}
          <div className='center-ac text-center'>
            <span className='center-title'>Weight & Balance Planner</span>
            <span className='ac-name'>{acName}</span>
          </div>
        </Col>
        <Col>
          <DryIce fleetType={this.props.editRecord?.fleet} ship_no={this.state.ship} />
        </Col>
        <Col flex='none' className='content-ht-half'>
          <div className='my-2 logo'><img src={deltaLogo} /></div>
        </Col>
      </Row>

    const renderTabContent = () => (
      <>
        <AcDetails
          fleet={this.props.editRecord?.fleet}
          onChange={this.onChange}
          onChangePax={this.onChangePax}
          ship={this.state.ship}
          type={this.state.type}
          wgt_unit={this.props.wgt_unit}
          pax={this.state.pax}
          fuel={this.state.fuel}
          season={this.state.season}
          aft_index={this.state.aft_index}
          wgt_bal_status={this.state.wgt_bal_status}
          aftIndexStyle={this.aftIndexStyle}
          aftStatus={this.aftStatus}
          cargo_margin={this.state.cargo_margin}
          ccPlanModalVisible={this.state.ccPlanModalVisible}
          onSubmit={this.onSubmit}
          isSubmitTimerActive={this.state.isSubmitTimerActive}
        />
        {acType}
      </>
    )
    return (
      <Modal
        title={null}
        open={this.props.openPlanner}
        closable={true}
        onCancel={() => this.props.openWB(false)}
        zIndex={1001}
        footer={this.props.disableInputs ? false : <>
          <Space size='middle' align='center' className=' wnb-btn-container'>
            <Space size='middle'>
              {!this.state.copy && cookies.get('station') === 'LHR' && <Button className='wnb-footer-button' onClick={this.trimPlan}>Trim Plan</Button>}
              {!this.state.copy && this.state.record?.trim_plan && <Button className='wnb-footer-button' onClick={() => this.openTruckPlanner(true)}>View</Button>}
            </Space>
            <Space size='middle' align='flex-end' className=' wnb-btn-container'>
              {!this.state.copy && <Button className='wnb-footer-button' onClick={this.handleLockAndScreenshot}>Lock W & B</Button>}
              <Button className='wnb-footer-button mr-2' onClick={() => this.props.openWB(false)}> Close  </Button>
            </Space>
          </Space>
        </>
        }
        width='100%'
        centered
        className='custom-modal pb-0 wnb-modal'
      >
        <div ref={this.modalContentRef}>
          {modalTitle}
          <div className='wnb-switch-container'>
            <Space size='small' className='wnb-switch'>
              <span className='switch-label'>Aircraft View : &nbsp;</span>
              <span className='switch-label'>Small</span>
              <Switch
                checkedChildren=''
                unCheckedChildren=''
                size='default'
                checked={this.state.viewMode === 'lg'}
                onChange={(e) => this.setState({ viewMode: e ? 'lg' : 'sm' })}
              />
              <span className='switch-label'>Large</span>
            </Space>
          </div>
          <Tabs
            activeKey={this.state.activeTab}
            onChange={this.callbackTabClicked}
            onEdit={this.onTabEdit}
            type='editable-card'
            hideAdd
            className='wnb-tab position-relative'
          >
            <TabPane tab='W&B' key='wnb' closable={false}>{renderTabContent()}</TabPane>
            {this.state.record?.init_wgt_bal_plan &&
              <TabPane tab='Proposed' key='initial' closable={true}>{renderTabContent()}</TabPane>

            }
            {this.state.record?.final_wgt_bal_plan &&
              <TabPane tab='Final' key='final' closable={true}>{renderTabContent()}</TabPane>
            }
          </Tabs>
          <ContainerDetails
            fleet={this.props.editRecord?.fleet}
            wgt_unit={this.props.wgt_unit}
            data={this.state.record?.wgt_bal_plan || {
              position: {
                pallet_uld: {},
                pallet: {}
              }
            }} ulds={this.state.ulds} />
        </div>
        {
          this.state.truckplanner &&
          <TruckLoading
            openTruckPlanner={this.openTruckPlanner}
            truckplanner={this.state.truckplanner}
            editRecordId={this.state.recordid}
            editRecord={this.state.record}
          />
        }
      </Modal>
    )
  }
}
export default WeightAndBalance
